import Main from './Main';
import Vue from 'vue';
import {Popup, Stepper} from 'vant';

Vue.use(Popup);
Vue.use(Stepper);
import * as API from '@/api/shop';

const Com = Vue.extend(Main);

function createVm(opt) {
  const vm = new Com({data: opt}).$mount();
  document.body.appendChild(vm.$el);
  return vm;
}

const dftOpt = {
  guid: '',
  hasSku: false
};

export default (opt = {}) => new Promise(async resolve => {
  opt = {...dftOpt, ...opt};
  const task = [
	API.getGoodsDetail(opt.guid)
  ];
  if (opt.hasSku) {
	task.push(
		API.getGoodsSku(opt.guid)
	);
  }

  const [detail, sku] = await Promise.all(task);
  if (!detail.success) return resolve({success: false});
  if (opt.hasSku && !sku.success) return resolve({success: false});

  let vm = createVm({resolve, detail: detail.data, skuData: sku ? sku.data : null});
  vm.show = true;
})
